import React from "react";
import { Badge } from "reactstrap";

/**
 * Uses jobseeker_data API: profile_completion_sections[sectionKey].{ complete, weight }
 * Shows "+10%" only while the section is incomplete; hidden once data is present.
 */
const ProfileSectionCompletionBadge = ({
  sectionKey,
  profileData,
  className = "",
}) => {
  const meta = profileData?.profile_completion_sections?.[sectionKey];
  if (!meta || Boolean(meta.complete)) {
    return null;
  }
  const weight = typeof meta.weight === "number" ? meta.weight : 10;

  return (
    <Badge
      pill
      color="success"
      className={`ms-2 fw-normal align-middle text-white border-0 ${className}`}
      style={{
        fontSize: "0.75rem",
        verticalAlign: "middle",
        opacity: 0.88,
      }}
      title={`Complete this section to add ${weight}% to your profile`}
    >
      {`+${weight}%`}
    </Badge>
  );
};

export default ProfileSectionCompletionBadge;
